// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';

// const firebaseConfig = {
//   // Your Firebase configuration
// };

// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);

// import * as firebase from 'firebase'
import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  signOut,                    // eslint-disable-line
  getAuth,
  onAuthStateChanged,
  reauthenticateWithCredential,
  EmailAuthProvider
} from "firebase/auth";       // eslint-disable-line
// import * as admin from 'firebase-admin'
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID
};

const app = initializeApp(firebaseConfig); // eslint-disable-line
const auth = getAuth();
const googleAuthProvider = new GoogleAuthProvider();
// TBD: potential options
// googleAuthProvider.addScope('https://www.googleapis.com/auth/contacts.readonly');
// googleAuthProvider.setCustomParameters({
//   'login_hint': 'user@example.com'
// });
export { auth, googleAuthProvider };

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    // const uid = user.uid;
    // console.log("====> User is signed in", uid);
  } else {
    // User is signed out
    // console.log("========> User is signed out");
  }
});
